// TrumpfBlatt - public site scripts. Plain JS, no framework.
var tracking = require('./tracking');
var track = tracking.track;

tracking.start();

(function () {
  // Hero upload: the red pill is button and drop target at once. A picked
  // photo opens the free preview dialog (web/templates/web/_preview_dialog.html):
  // gender, look -> POST /vorschau/ -> poll until the figure (~15 s)
  // and then the card (~30 s) are there. A browser that already has its
  // preview gets it shown again instead of the file picker.
  var zone = document.querySelector('[data-dropzone]');
  var dialog = document.querySelector('[data-preview-dialog]');
  if (zone && dialog) {
    var heroForm = document.querySelector('[data-hero-form]');
    var input = document.querySelector('[data-upload-input]');
    var hint = zone.querySelector('[data-dropzone-hint]');
    var hintText = hint ? hint.textContent : '';
    var form = dialog.querySelector('[data-preview-form]');
    var errorBox = dialog.querySelector('[data-preview-error]');
    var submit = dialog.querySelector('[data-preview-submit]');
    var photo = null, timer = null, clock = null, captionTimer = null;

    var step = function (name) {
      dialog.querySelectorAll('[data-preview-step]').forEach(function (el) { el.hidden = el.dataset.previewStep !== name; });
      if (!dialog.open) dialog.showModal();
    };
    var fail = function (text, retry) {
      dialog.querySelector('[data-preview-failed-text]').textContent = text;
      dialog.querySelector('[data-preview-retry]').hidden = !retry;
      step('failed');
    };
    var showError = function (text) {
      errorBox.textContent = text;
      errorBox.classList.toggle('hidden', !text);
    };

    // The finished card takes Markus's place in the hero, the upload makes
    // way for the next step - the same markup the server renders on reload.
    var showOwn = function (state) {
      var own = document.querySelector('[data-hero-own]');
      if (!own) return;
      own.querySelector('[data-hero-own-photo]').src = state.photo;
      var card = own.querySelector('[data-hero-own-card]');
      card.classList.toggle('border-white', state.border === 'white');
      card.querySelector('img').src = state.card;
      document.querySelector('[data-hero-own-download]').href = state.download;
      // with a card in hand, the whole deck is the next step everywhere
      document.querySelectorAll('[data-when-fresh]').forEach(function (el) { el.hidden = true; });
      document.querySelectorAll('[data-when-own]').forEach(function (el) { el.hidden = false; });
      document.querySelectorAll('[data-deck-link]').forEach(function (el) { el.classList.replace('btn-secondary', 'btn-primary'); });
      own.hidden = false;
      document.querySelector('[data-hero-default]').hidden = true;
      document.querySelector('[data-hero-own-cta]').hidden = false;
      heroForm.hidden = true;
    };
    // Saving the card on iOS: Safari ignores `download` on a link to the bucket (another origin) and
    // only opens the picture; into Photos it goes through the share sheet ("Bild sichern").
    // navigator.share needs the tap's user activation, which waiting on a fetch loses - so the file
    // is fetched as soon as the card is there (the bucket answers with CORS) and waits for the tap.
    // Elsewhere, or when the fetch failed, the link downloads as before.
    var isIOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var shareFile = { url: null, file: null };
    var prepareShare = function (url) {
      if (!isIOS || !url || !navigator.canShare) return;
      url = new URL(url, location.href).href;        // as `a.href` reads it, to compare on the tap
      if (shareFile.url === url) return;
      shareFile = { url: url, file: null };
      fetch(url, { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.ok ? r.blob() : Promise.reject(r.status); })
        .then(function (blob) {
          var file = new File([blob], 'TrumpfBlatt-Vorschau.png', { type: blob.type || 'image/png' });
          if (shareFile.url === url && navigator.canShare({ files: [file] })) shareFile.file = file;
        })
        .catch(function () {});
    };
    document.querySelectorAll('[data-preview-download], [data-hero-own-download]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        track('preview_download');
        if (!shareFile.file || shareFile.url !== a.href) return;
        e.preventDefault();
        navigator.share({ files: [shareFile.file] }).catch(function (err) {
          if (err && err.name !== 'AbortError') window.location.href = a.href;   // cancelled = nothing
        });
      });
    });
    var ownDownload = document.querySelector('[data-hero-own-download]');
    if (ownDownload && ownDownload.getAttribute('href')) prepareShare(ownDownload.href);
    var ownCard = document.querySelector('[data-hero-own-card]');
    if (ownCard) ownCard.addEventListener('click', function () { follow(heroForm.dataset.existingPreview); });

    var pick = function (files) {
      if (!files || !files.length) return;
      if (!/^image\//.test(files[0].type) && files[0].type) { showError(''); fail('Das ist kein Foto. Bitte nimm ein JPG oder PNG.', true); return; }
      photo = files[0];
      var img = dialog.querySelector('[data-preview-photo]');
      img.src = URL.createObjectURL(photo);
      showError('');
      step('form');
    };

    // Person or pet: a pet shows the species chips, its genders read
    // Männchen/Weibchen and "Divers" goes away.
    var setKind = function () {
      var pet = form.querySelector('[data-kind]:checked').value === 'pet';
      form.querySelectorAll('[data-pet-only]').forEach(function (el) { el.hidden = !pet; });
      form.querySelectorAll('[data-human-only]').forEach(function (el) { el.hidden = pet; });
      form.querySelectorAll('[data-pet]').forEach(function (el) { el.textContent = pet ? el.dataset.pet : el.dataset.human; });
      var diverse = form.querySelector('[name=gender][value=d]');
      if (pet && diverse.checked) form.querySelector('[name=gender][value=m]').checked = true;
    };
    form.querySelectorAll('[data-kind]').forEach(function (el) { el.addEventListener('change', setKind); });
    var other = form.querySelector('[data-species-other-input]');
    // "Anderes" makes the animal's name a required field (only for a pet)
    var syncOther = function () {
      var pet = form.querySelector('[data-kind]:checked').value === 'pet';
      other.hidden = !(pet && form.querySelector('[data-species-other]').checked);
      other.required = !other.hidden;
    };
    form.querySelectorAll('[name=species]').forEach(function (el) {
      el.addEventListener('change', function () { syncOther(); if (!other.hidden) other.focus(); });
    });
    form.querySelectorAll('[data-kind]').forEach(function (el) { el.addEventListener('change', syncOther); });

    // --- the loading rings ---------------------------------------------
    // Fill in 15 s; if the step is not done by then, spin in full.
    var ringStage = null, ringTimers = [];
    var startRing = function (el) {
      if (!el) return;
      el.classList.remove('is-filling', 'is-waiting');
      void el.offsetWidth;                 // restart the CSS animation
      el.classList.add('is-filling');
      ringTimers.push(setTimeout(function () { el.classList.replace('is-filling', 'is-waiting'); }, 15000));
    };
    var resetRings = function () {
      ringTimers.forEach(clearTimeout);
      ringTimers = [];
      ringStage = null;
      dialog.querySelectorAll('[data-ring]').forEach(function (el) { el.classList.remove('is-filling', 'is-waiting'); });
    };

    // --- polling -------------------------------------------------------
    var follow = function (url) {
      var started = Date.now();
      var live = false;       // saw it painting: its end is a new free card (generate_lead)
      resetRings();
      step('progress');
      clearInterval(clock);
      clock = setInterval(function () {
        dialog.querySelector('[data-preview-seconds]').textContent = Math.round((Date.now() - started) / 1000) + ' s';
      }, 1000);
      var poll = function () {
        fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () { timer = setTimeout(poll, 4000); });
      };
      var slot = dialog.querySelector('[data-preview-slot]');
      var livePhoto = slot.querySelector('[data-preview-live]');
      var figureImg = slot.querySelector('[data-preview-figure]');
      slot.classList.remove('has-figure', 'is-complete', 'is-painting');
      figureImg.hidden = true;
      livePhoto.classList.remove('is-shown');
      delete livePhoto.dataset.src;
      // the photo that is being painted: the one just picked, or the preview's own
      var showLive = function (src) {
        if (!src || livePhoto.dataset.src === src) return;
        livePhoto.dataset.src = src;
        livePhoto.onload = function () { livePhoto.classList.add('is-shown'); };
        livePhoto.src = src;
      };
      if (photo) showLive(URL.createObjectURL(photo));
      // the confetti: the chosen game's suit symbols, then the chosen style's example cards (web/magic.py)
      var magic = slot.querySelector('[data-magic]');
      var magicUrls = JSON.parse((document.getElementById('magic-urls') || {}).textContent || '{}');
      var magicKey = null;
      var setMagic = function (style, kind) {
        var set = (magicUrls[style] || {})[kind];
        if (!magic || !set || !set.length || magicKey === style + kind) return;
        magicKey = style + kind;
        magic.querySelectorAll('img').forEach(function (img, i) { img.src = set[i % set.length]; });
        magic.classList.toggle('is-cards', kind === 'cards');
      };
      var chosen = form.querySelector('[name=style]:checked');
      if (photo && chosen) setMagic(chosen.value, 'symbols');
      // a joking caption over the picture, a new one every 2.8 s - first about the figure, then the costume
      var caption = slot.querySelector('[data-magic-caption]');
      var CAPTIONS = {
        anchor: ['Pinsel werden ausgewaschen …', 'Farben werden gemischt …', 'Nase wird gezeichnet …', 'Lächeln wird eingefangen …',
                 'Haare werden frisiert …', 'Augen bekommen Glanz …', 'Noch ein Tupfer hier …'],
        card: ['Kostüm wird genäht …', 'Krone wird anprobiert …', 'Hintergrund wird gemalt …', 'Zauberstab wird poliert …',
               'Licht wird gesetzt …', 'Letzter Feinschliff …']
      };
      var captionStage = null, captionAt = 0;
      clearInterval(captionTimer);
      var nextCaption = function () {
        var list = CAPTIONS[captionStage];
        if (!list) { caption.classList.remove('is-shown'); return; }
        caption.classList.remove('is-shown');
        setTimeout(function () {
          caption.textContent = list[captionAt++ % list.length];
          caption.classList.add('is-shown');
        }, 250);
      };
      var setCaptions = function (stage) {
        if (stage === captionStage) return;
        captionStage = stage;
        captionAt = 0;
        clearInterval(captionTimer);
        nextCaption();
        if (CAPTIONS[stage]) captionTimer = setInterval(nextCaption, 2800);
      };
      var render = function (state) {
        var order = ['queued', 'anchor', 'card', 'done'];
        var at = order.indexOf(state.status);
        if (at >= 0 && at < 3) live = true;
        // a new step starts both rings (the big one and the step's) from empty
        var stage = at <= 1 ? 'anchor' : state.status;
        if (stage !== ringStage) {
          ringStage = stage;
          if (stage !== 'done') {
            startRing(slot.querySelector('[data-ring]'));
            startRing(dialog.querySelector('[data-progress="' + stage + '"] [data-ring]'));
          }
        }
        slot.classList.toggle('is-complete', stage === 'done');
        ['anchor', 'card'].forEach(function (name) {
          var li = dialog.querySelector('[data-progress="' + name + '"]');
          var i = order.indexOf(name);
          li.classList.toggle('is-done', at > i);
          li.classList.toggle('is-active', at === i || (name === 'anchor' && at === 0));
        });
        if (!photo) showLive(state.photo);
        setCaptions(state.status === 'done' || state.status === 'failed' ? null : (state.figure ? 'card' : 'anchor'));
        if (state.style) setMagic(state.style, state.figure ? 'cards' : 'symbols');
        slot.classList.toggle('is-painting', !state.figure && at >= 0 && at <= 1);
        if (state.figure && figureImg.hidden) {
          // the figure arrives: wait for the file, then photo and brushes give way to it
          figureImg.onload = function () { figureImg.hidden = false; slot.classList.add('has-figure'); slot.classList.remove('is-painting'); };
          figureImg.src = state.figure;
        }
        if (state.status === 'done') {
          clearInterval(clock);
          dialog.querySelector('[data-preview-card]').src = state.card;
          dialog.querySelector('[data-preview-card-frame]').classList.toggle('border-white', state.border === 'white');
          dialog.querySelector('[data-preview-download]').href = state.download;
          prepareShare(state.download);
          dialog.querySelector('[data-preview-deck]').href = state.deck_url;
          step('done');
          showOwn(state);
          if (live) { live = false; track('generate_lead', { style: state.style, kind: state.kind }); }
          return;
        }
        if (state.status === 'failed') {
          // a failed run does not use up the free card: the next photo starts afresh
          clearInterval(clock);
          delete heroForm.dataset.existingPreview;
          fail(state.error, true);
          return;
        }
        timer = setTimeout(poll, 2000);
      };
      poll();
    };

    // --- the form ------------------------------------------------------
    form.addEventListener('invalid', function () { form.classList.add('is-checked'); }, true);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // the browser has checked the required fields (consent, "Anderes" animal) before this fires
      var data = new FormData(form);
      data.append('photo', photo);
      showError('');
      submit.disabled = true;
      submit.textContent = 'Lädt hoch …';
      fetch(form.action, { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, status: r.status, body: body }; }); })
        .then(function (res) {
          if (res.ok) {
            track('preview_start', { style: data.get('style'), kind: data.get('kind') });
            heroForm.dataset.existingPreview = res.body.status_url;
            follow(res.body.status_url);
          }
          else if (res.status === 429) fail(res.body.error, false);
          else showError(res.body.error || 'Das hat nicht geklappt. Versuch es noch einmal.');
        })
        .catch(function () { showError('Keine Verbindung. Versuch es noch einmal.'); })
        .then(function () { submit.disabled = false; submit.textContent = 'Karte malen lassen'; });
    });

    var close = function () { clearTimeout(timer); clearInterval(clock); clearInterval(captionTimer); resetRings(); if (dialog.open) dialog.close(); };
    dialog.querySelectorAll('[data-preview-close]').forEach(function (el) { el.addEventListener('click', close); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    dialog.addEventListener('close', function () { clearTimeout(timer); clearInterval(clock); clearInterval(captionTimer); input.value = ''; });
    dialog.querySelector('[data-preview-retry]').addEventListener('click', function () { close(); input.click(); });

    // --- the hero pill -------------------------------------------------
    var open = function () {
      var existing = heroForm.dataset.existingPreview;
      if (existing) follow(existing); else input.click();
    };
    zone.addEventListener('click', open);
    // "Gratis-Karte erstellen" in the game panels: the same flow, that game's look preselected
    document.querySelectorAll('[data-free-card]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var radio = form.querySelector('[name=style][value="' + btn.dataset.freeCard + '"]');
        if (radio) radio.checked = true;
        open();
      });
    });
    input.addEventListener('change', function () { pick(input.files); });
    ['dragenter', 'dragover'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) {
        e.preventDefault();
        zone.classList.add('is-over');
        if (hint) hint.textContent = 'Jetzt loslassen';
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      zone.addEventListener(ev, function (e) {
        e.preventDefault();
        zone.classList.remove('is-over');
        if (hint) hint.textContent = hintText;
      });
    });
    zone.addEventListener('drop', function (e) {
      if (heroForm.dataset.existingPreview) follow(heroForm.dataset.existingPreview); else pick(e.dataTransfer.files);
    });
    // every "Erste Karte kostenlos" link goes straight to the picker
    document.querySelectorAll('a[href="#gratis"]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
  }

  // Deck product page: the payment is not wired yet - "Weiter" says so.
  // Product page: extra printed copies only with the print; the form GETs the checkout.
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var extraBox = productForm.querySelector('[data-extra-copies]');
    var extra = productForm.querySelector('[data-extra]');
    var syncExtra = function () {
      var printed = productForm.querySelector('[name=druck]:checked').value === '1';
      extraBox.classList.toggle('is-hidden', !printed);
      extra.disabled = !printed;
    };
    productForm.querySelectorAll('[name=druck]').forEach(function (r) { r.addEventListener('change', syncExtra); });
    productForm.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        extra.value = Math.max(0, Math.min(10, (parseInt(extra.value, 10) || 0) + parseInt(b.dataset.step, 10)));
      });
    });
    productForm.addEventListener('submit', function () {
      if (!(parseInt(extra.value, 10) > 0)) extra.disabled = true;     // keep the URL clean
    });
    syncExtra();
  }

  // Style switcher: sliding thumb, auto-cycles until the visitor clicks.
  document.querySelectorAll('[data-style-switch]').forEach(function (group) {
    var buttons = Array.prototype.slice.call(group.querySelectorAll('button'));
    var thumb = group.querySelector('.switch-thumb');
    var target = document.querySelector(group.dataset.styleSwitch);
    var current = 0, timer = null;
    var moveThumb = function (btn) {
      if (!thumb) return;
      thumb.style.left = btn.offsetLeft + 'px';
      thumb.style.width = btn.offsetWidth + 'px';
    };
    var select = function (i) {
      current = i;
      buttons.forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
      moveThumb(buttons[i]);
      var value = buttons[i].dataset.value;
      // all looks stay in the DOM on top of each other; toggling the class cross-fades them
      target.querySelectorAll('[data-style]').forEach(function (el) { el.classList.toggle('is-current', el.dataset.style === value); });
    };
    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        select(i);
        if (timer) { clearInterval(timer); timer = null; }
        track('select_content', { content_type: 'style', content_id: btn.dataset.value });
      });
    });
    select(0);
    window.addEventListener('resize', function () { moveThumb(buttons[current]); });
    var every = parseInt(group.dataset.auto || '0', 10);
    if (every) timer = setInterval(function () { select((current + 1) % buttons.length); }, every);
  });

  // The cards in step 2 change their look on their own - same cross-fade as
  // the gallery, but without a switch: it IS the "choose a style" step.
  document.querySelectorAll('[data-style-cycle]').forEach(function (group) {
    var cards = Array.prototype.slice.call(group.querySelectorAll('[data-style]'));
    var label = group.querySelector('[data-style-label]');
    var styles = [];
    cards.forEach(function (el) { if (styles.indexOf(el.dataset.style) < 0) styles.push(el.dataset.style); });
    if (styles.length < 2) return;
    var i = 0;
    setInterval(function () {
      i = (i + 1) % styles.length;
      cards.forEach(function (el) { el.classList.toggle('is-current', el.dataset.style === styles[i]); });
      if (label) label.textContent = cards.filter(function (el) { return el.dataset.style === styles[i]; })[0].dataset.styleName;
    }, parseInt(group.dataset.styleCycle, 10) || 4000);
  });

  // Hero card stack: the front card swings out to the left and slides to
  // the back, the others move one step forward.
  document.querySelectorAll('[data-card-stack]').forEach(function (stack) {
    var cards = Array.prototype.slice.call(stack.querySelectorAll('[data-stack-card]'));
    if (cards.length < 2) return;
    var order = cards.slice();
    var apply = function () { order.forEach(function (c, i) { c.style.setProperty('--i', i); }); };
    var shuffle = function () {
      var front = order.shift();
      front.classList.add('is-leaving');
      setTimeout(function () { order.push(front); front.classList.remove('is-leaving'); apply(); }, 500);
    };
    var timer = setInterval(shuffle, 3400);
    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        var i = order.indexOf(card);
        if (i > 0) { order.splice(i, 1); order.unshift(card); apply(); }
        clearInterval(timer);
        timer = setInterval(shuffle, 6000);  // pause a little longer after a click
      });
    });
    apply();
  });

  // Fade-up on scroll.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('animate-fade-up'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.style.opacity = '0'; io.observe(el); });
  }
})();
